import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Section from './pages/Section';
import Question from './pages/Question';
import Audit from './pages/Audit';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/shadow-ai-benchmark-report-2026" replace />} />
          <Route path="shadow-ai-benchmark-report-2026" element={<Home />} />
          <Route path="ai-governance-audit" element={<Audit />} />
          
          {/* Dynamic Routes */}
          {/* We use generic params but the components validate against reportData */}
          <Route path=":slug" element={<DynamicRouteHandler />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

// Helper component to determine if slug is a section or question
import { useParams } from 'react-router-dom';
import { reportData } from './data/reportData';

function DynamicRouteHandler() {
  const { slug } = useParams();
  
  const isSection = reportData.sections.some(s => s.slug === slug);
  if (isSection) return <Section />;
  
  const isQuestion = !!reportData.questions[slug];
  if (isQuestion) return <Question />;
  
  // 404 fallback
  return <Navigate to="/shadow-ai-benchmark-report-2026" replace />;
}

export default App;